import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2","key":"svg-0"}],["path",{"d":"M7 11l5 5l5 -5","key":"svg-1"}],["path",{"d":"M12 4l0 12","key":"svg-2"}]]

/**
 * IconDownload
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZG93bmxvYWQiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTd2MmEyIDIgMCAwIDAgMiAyaDEyYTIgMiAwIDAgMCAyIC0ydi0yIiAvPgogIDxwYXRoIGQ9Ik03IDExbDUgNWw1IC01IiAvPgogIDxwYXRoIGQ9Ik0xMiA0bDAgMTIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/download
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDownload = createReactComponent('outline', 'download', 'Download', __iconNode);

export default IconDownload;